
import { Prop, Component, Vue } from 'nuxt-property-decorator';
import Swiper, { A11y, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import { Reference } from '@sanity/types';
import {
  SanityDocumentSchema,
  ISanityDocuments,
} from '~/types/sanity-documents';
import FilmsPromoPosterSlide from '~/components/Home/FilmsPromoPosterSlide.vue';

@Component({
  components: {
    FilmsPromoPosterSlide,
  },
})
export default class FilmsPromoPosterCarousel extends Vue {
  get slideWidth() {
    return 375;
  }

  get aspectRatio() {
    return 75 / 106;
  }

  schemas = SanityDocumentSchema;

  slug = 'landing-page-promo';

  async fetch() {
    await this.$sanityLookup.fetchDocument({
      _type: SanityDocumentSchema.PROMO_CAROUSEL,
      slug: this.slug,
      fetchReferences: true,
    });
  }

  get docState() {
    return (
      this.$sanityLookup.getDocumentFromIdOrSlug<
        ISanityDocuments[SanityDocumentSchema.PROMO_CAROUSEL]
      >({
        _type: SanityDocumentSchema.PROMO_CAROUSEL,
        slug: this.slug,
      }) || {
        isLoading: false,
        hasError: false,
      }
    );
  }

  get items() {
    return this.docState?.data?.slides;
  }

  mounted() {
    const el = this.$refs?.swiperContainer as HTMLElement;
    if (!el) {
      return;
    }

    new Swiper(el, {
      slidesPerView: 'auto',
      modules: [A11y, Navigation, Pagination],
      navigation: {
        nextEl: `#${this.$id('next-btn')}`,
        prevEl: `#${this.$id('prev-btn')}`,
      },
      a11y: {
        nextSlideMessage: this.$t(
          'components.films.filmMediaTab.nextSlide',
        ) as string,
        prevSlideMessage: this.$t(
          'components.films.filmMediaTab.prevSlide',
        ) as string,
        paginationBulletMessage: this.$t(
          'components.films.filmMediaTab.goToSlide',
          { i: '{{index}}' },
        ) as string,
        slideLabelMessage: this.$t('components.films.filmMediaTab.slideLabel', {
          current: '{{index}}',
          total: '{{slidesLength}}',
        }) as string,
      },
    });
  }
}
